export default __webpack_public_path__ + "static/media/copy-content.fa8eac34.svg";